import React from 'react';
import { Typography, Tooltip, makeStyles } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { ICustomTheme } from 'interfaces';

export interface StyleProps {
  iconColor: string;
}

const useStyle = makeStyles<ICustomTheme, StyleProps>(
  (theme: ICustomTheme) => ({
    tooltip: {
      width: 250,
      backgroundColor: theme.colors.grey.light5,
      boxShadow: '0 10px 20px 0 rgba(175, 187, 199, 0.3)',
      padding: theme.spacing(2),
    },
    icon: (props) => ({
      color: props.iconColor,
    }),
    typo: {
      margin: 0,
      color: theme.colors.grey.main,
      fontSize: theme.typography.body2.fontSize,
    },
  }),
);

const QuestionTooltip = ({
  tooltipText,
  iconColor,
}: {
  tooltipText: string;
  iconColor: string;
}) => {
  const classes = useStyle({ iconColor });

  return (
    <Tooltip
      enterTouchDelay={0}
      interactive
      placement="bottom-start"
      classes={{
        tooltip: classes.tooltip,
      }}
      title={
        <Typography className={classes.typo} paragraph>
          {tooltipText}
        </Typography>
      }
    >
      <HelpIcon className={classes.icon} fontSize="large" />
    </Tooltip>
  );
};

export default QuestionTooltip;
